import { getQuestionnaireFromUrl } from '../../../utils/getQuestionnaireFromUrl'
import type {
  QuestionnaireStrategy,
  QuestionnaireSelectionResult,
  SelectionContext,
} from '../types'

/**
 * Strategy: Extract questionnaire from URL query parameter
 * Priority: Highest (1st)
 *
 * Behavior:
 * - Valid questionnaire in URL → use it and stop chain
 * - Invalid questionnaire explicitly provided → fallback to 'default' and stop chain
 * - No questionnaire parameter → continue to next strategy
 */
export const createUrlQuestionnaireStrategy = (): QuestionnaireStrategy => ({
  name: 'url',

  execute: (_context: SelectionContext): QuestionnaireSelectionResult => {
    const { questionnaire, hasInvalidParam } = getQuestionnaireFromUrl()

    if (questionnaire) {
      return {
        questionnaire,
        shouldContinue: false,
        reason: 'Valid questionnaire found in URL',
      }
    }

    if (hasInvalidParam) {
      return {
        questionnaire: 'default',
        shouldContinue: false,
        reason: 'Invalid questionnaire in URL, using default',
      }
    }

    return {
      questionnaire: null,
      shouldContinue: true,
      reason: 'No questionnaire in URL',
    }
  },

  isEnabled: () => true,
})
